export default {
	tenantId: "boclife_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "boclife--uat"
	}
}
